module.exports = __webpack_public_path__ + "img/bar-chart.a9fc7ca4.png";